<template>
  <div>
    <b-card class="cardView">
      <img :src="imageSrc" class="image" />
      <b-row>
        <b-col class="text-black font-weight-bold"
          >{{ bedInfo }} Bed {{ bathInfo }} Bath</b-col
        >
        <b-col class="text-black font-weight-bold">No of Unit: {{ unitCount }}</b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    bedInfo: {
      type: String,
      required: true,
      default: "1",
    },
    bathInfo: {
      type: String,
      required: true,
      default: "1",
    },
    unitCount: {
      type: Number,
      required: true,
      default: 4,
    },
    imageSrc: {
      type: String,
      required: true,
      default: "@/assets/images/building.jpg",
    },
  },
};
</script>

<style scoped>
.cardView {
  width: 100%;
  max-width: 275px;
  height: auto;
  min-height: 188px;
}
.image {
  width: 100%;
  max-width: 255px;
  height: auto;
  min-height: 130px;
  object-fit: cover;
}

@media (max-width: 576px) {
  .cardView {
    max-width: 100%;
  }
  .image {
    max-width: 100%;
  }
}
</style>
